import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {CashDesk, TicketCashDesk} from '../Model'
import {T} from 'helpers/i18n'
import {toMoney, toPercentage, toDateTime, toRound} from 'helpers/Format'
import {Table} from 'components'
import Report from '../components/Report'
import history from '../../../helpers/History'

interface Props {
  store?: Store
}

@inject('store')
@observer
class TicketCashDesks extends PureComponent<Props, object> {
  componentDidMount() {
    this.props.store!.reports.readTicketCashDesks()
  }

  handleOnSelectItem = (item) => {
    console.error((item as any).id)
    history.push(`/ticketCashDesk/${item.id}`, item)
  }

  render() {
    const {reports} = this.props.store!
    const headers = ['dateOpen', 'dateClose', 'username', 'terminal', 'modelo', 'tickets', 'checkins', 'totalDiscount', 'ticketsRefunded','totalRefund' , 'total']
    const items = reports.ticketCashDesk
    console.log( 'TicketCashDesks - items: ', items.length)
    return (
      <Report
        onSelectItem={this.handleOnSelectItem}
        filterDate={false}
        header={headers}
        items={items}
        loading={!reports.ticketCashDesksLoaded}
        keyExtractor={(ticketCashDesk: TicketCashDesk) => String(ticketCashDesk.id)}
        format={(ticketCashDesks: TicketCashDesk[]) =>
          ticketCashDesks.map(ticketCashDesk => ({
            ...ticketCashDesk,
            dateOpen: toDateTime(ticketCashDesk.dateOpen),
            dateClose: toDateTime(ticketCashDesk.dateClose),
            checkins: ticketCashDesk.checkins,
            tickets: numeroTickets(ticketCashDesk, 'printed'),
            username: ticketCashDesk.username,
            terminal: ticketCashDesk.terminalSN,
            modelo: ticketCashDesk.terminalBrand,
            total: toRound(ticketCashDesk.total).toString() + ' EUR',
            totalDiscount: toRound(ticketCashDesk.totalDiscount).toString() + ' EUR',
            ticketsRefunded: numeroTickets(ticketCashDesk, 'refunded'),
            totalRefund: toRound(ticketCashDesk.totalRefund).toString() + ' EUR'
          }))}
      />
    )
  }
}

export const numeroTickets = (item: TicketCashDesk, type: string) => {
  console.log('numeroTickets - item: ', item)
  let typeTicket
  switch (type) {
    case 'printed': typeTicket = 'printedTickets'; break
    case 'refunded': typeTicket = 'refundTickets'; break
    case 'bookinged': typeTicket = 'bookingTickets'; break
    default: typeTicket = 'printedTickets'
  }
  console.log('typeTicket', typeTicket)
  console.log('item[typeTicket]', item[typeTicket])
  const temp = item[typeTicket]
  console.log('temp: ', temp)
  const tickets = temp[type]
  console.log('TicketCashDesk - numeroTickets - tickets: ', tickets)
  return tickets.length
}

export default TicketCashDesks



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/containers/TicketCashDesks.tsx